var _excluded = ["event_name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { getLocalStorageItem } from './localStorageUtil';
import { IS_CLIENT } from './browserUtils';
var eventData = {};
var loggingPrefix = '%cAdvertorial';
var loggingStyle = 'display: inline-block; color: #fff; background: #1CB954; padding: 1px 4px; border-radius: 3px;';

var isDebugEnabled = function isDebugEnabled() {
  return getLocalStorageItem('rui-debug') === 'true';
};

var log = function log() {
  if (isDebugEnabled()) {
    var _console;

    for (var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++) {
      message[_key] = arguments[_key];
    }

    (_console = console).log.apply(_console, [loggingPrefix, loggingStyle].concat(message));
  }
};

var logWarning = function logWarning() {
  var _console2;

  for (var _len2 = arguments.length, message = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    message[_key2] = arguments[_key2];
  }

  (_console2 = console).warn.apply(_console2, [loggingPrefix, loggingStyle].concat(message));
};

var logError = function logError() {
  var _console3;

  for (var _len3 = arguments.length, message = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    message[_key3] = arguments[_key3];
  }

  (_console3 = console).error.apply(_console3, [loggingPrefix, loggingStyle].concat(message));
};

var logEvent = function logEvent(event, context) {
  var _event$data = event.data,
      eventName = _event$data.event_name,
      otherData = _objectWithoutProperties(_event$data, _excluded);

  var _context$media_ads$da = context.media_ads.data,
      groupId = _context$media_ads$da.group_id,
      position = _context$media_ads$da.position;
  eventData[groupId] = _objectSpread(_objectSpread({
    groupId: groupId,
    position: position
  }, eventData[groupId] || {}), otherData);
  log("".concat(position, " ").concat(eventName), otherData);
};

var logTable = function logTable(fields) {
  console.table(Object.values(eventData), fields);
};

if (IS_CLIENT) {
  window.RuiAdvertorial = {
    logTable: logTable
  };
}

var clearLoggingData = function clearLoggingData() {
  eventData = {};
};

export { log, logWarning, logError, logEvent, clearLoggingData, isDebugEnabled };
//# sourceMappingURL=loggingUtil.js.map